{
  "level": "field2",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:field2",
    "objects": "AREAS.E3:field2.e3",
    "mesh": "TREES.E3:field2.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2799.999755859375,
      "bbox_min": [
        -2799.999755859375,
        -4372.7998046875,
        1092.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4370.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: field2",
      "entity_class": "CSlidingDoor",
      "piece_name": "field2",
      "offset": 437,
      "centroid": [
        1505.0,
        1690.0,
        127.5
      ],
      "bbox_min": [
        1480.0,
        1690.0,
        120.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        135.0
      ],
      "dimensions_source": {
        "span_x": 50.0,
        "span_y": 0.0,
        "height_z": 15.0,
        "door_width": 50.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          1530.0,
          1690.0,
          120.0
        ],
        [
          1480.0,
          1690.0,
          120.0
        ],
        [
          1480.0,
          1690.0,
          135.0
        ],
        [
          1530.0,
          1690.0,
          135.0
        ]
      ],
      "plane_distance": 1690.0
    }
  ],
  "tutorial_messages": []
}